import { render } from "./AgentChatWidget.vue?vue&type=template&id=6b674948&scoped=true"
import script from "./AgentChatWidget.vue?vue&type=script&lang=js"
export * from "./AgentChatWidget.vue?vue&type=script&lang=js"

import "./AgentChatWidget.vue?vue&type=style&index=0&id=6b674948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b674948"]])

export default __exports__